import React, { useCallback, useEffect, useState } from "react";
import "../../../../Assets/CSS/bulkorder.css";
import "../../oms.css";
import Up from "../../../../Assets/Images/OMS/up.svg";
import Down from "../../../../Assets/Images/OMS/down.svg";
import Loading from "../../../../Assets/Images/OMS_New/unloading.svg";
import { Button, Chip, Grid, Stack } from "@mui/material";
import toast from "react-hot-toast";
import axios from "axios";

const quality_parameters_options = [
  { name: "Moisture", value: "moisture" },
  { name: "FM", value: "fm" },
  { name: "HM", value: "hm" },
  { name: "Discoloured grains", value: "discoloured_grains" },
  { name: "Broken grains", value: "broken_grains" },
  { name: "Shrivelled", value: "shrivelled" },
  { name: "Damaged grains", value: "damaged_grains" },
  { name: "Insects and fungi", value: "insects_and_fungi" },
  { name: "Gluten", value: "gluten" },
  { name: "Hardness", value: "hardness" },
  { name: "Kernel size", value: "kernel_size" },
  { name: "Odour", value: "odour" },
  { name: "Oil content", value: "oil_content" },
  { name: "Starch content", value: "starch_content" },
  { name: "Protein content", value: "protein_content" },
  { name: "Grain length", value: "grain_length" },
  { name: "Grain thickness", value: "grain_thickness" },
  { name: "Grain width", value: "grain_width" },
  { name: "Grain colour", value: "grain_colour" },
  { name: "Falling numbers", value: "falling_numbers" },
  { name: "Shruken", value: "shruken" },
  { name: "Other grains", value: "other_grains" },
];
function UnloadingDetailsBuyerForm({ orderId, omsData }) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";
  const [isExpanded, setIsExpanded] = useState(false);
  const [qualityParameterType, setQualityParameterType] = useState("");
  const [qualityParameterValue, setQualityParameterValue] = useState("");
  const [qualityParameter, setQualityParameter] = useState({});
  const [existingQualityParameter, setExistingQualityParameter] = useState(null);

  const getQualityParameter = async () => {
    try {
      const { data } = await axios.get(`/api/oms/quality_parameters/${orderId}`);
      if(data.status && data.quality_parameters) {
        setExistingQualityParameter(data.quality_parameters)
        const qp = {};
        const keysToSkip = ['id', 'order_id', 'merchant_type'];
        Object.keys(data.quality_parameters).forEach((key) => {
          if(keysToSkip.includes(key) || !data.quality_parameters[key]) {
            return;
          }
          qp[key] = data.quality_parameters[key]
        });
        setQualityParameter(qp)
      }
    } catch {

    }
  }

  useEffect(() => {
    getQualityParameter();
  }, []);

  const addQualityParam = useCallback(() => {
    if (!qualityParameterType || !qualityParameterValue) {
      toast.error("Missing type or value");
      return;
    }
    setQualityParameter((current) => ({
      ...current,
      [qualityParameterType]: qualityParameterValue,
    }));
    setQualityParameterType("");
    setQualityParameterValue("");
  }, [qualityParameterType, qualityParameterValue]);

  const handleDelete = useCallback(
    (key) => {
      if (isPending) {
        return;
      }
      const filteredObject = { ...qualityParameter };
      filteredObject[key] = '';
      setQualityParameter(filteredObject);
    },
    [qualityParameter]
  );


  const handleSubmit = async () => {
    try {
      const { data } = await axios.post("/api/oms/quality_parameters", {
        ...qualityParameter,
        order_id: orderId,
        merchant_type: 'buyer',
        ...(existingQualityParameter ? {id: existingQualityParameter.id} : {})
      });
      if (data.status) {
        toast.success(data.message);
        setQualityParameter({});
        getQualityParameter();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };


  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-2">
          <img src={Loading} alt="" />
          <div> Unloading Quality Parameters</div>
        </div>
        <div>
          {isExpanded ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() => setIsExpanded(!isExpanded)}
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() => setIsExpanded(!isExpanded)}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>
      <div>
        {isExpanded ? (
          <></>
        ) : (
          <div>
            <Grid item xs={12} sm={12} md={12} lg={6}>
              <div className="mb-3">
                <Stack
                  spacing={{ xs: 1, sm: 2 }}
                  direction="row"
                  useFlexGap
                  flexWrap="wrap"
                >
                  {Object.keys(qualityParameter)?.map((key) => {
                    if(!qualityParameter[key]) {
                      return null;
                    }
                    return (
                      <Chip
                        label={`${key} : ${qualityParameter[key]}`}
                        onDelete={() => handleDelete(key)}
                      />
                    );
                  })}
                </Stack>
              </div>
            </Grid>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Quality Parameter
                </label>
                <select
                  id="quality_parameter"
                  className="form-select"
                  aria-label="Default select example"
                  value={qualityParameterType}
                  onChange={(e) => setQualityParameterType(e.target.value)}
                  disabled={isPending}
                >
                  <option value="">--Select Parameter--</option>
                  {quality_parameters_options?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <div>
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label"
                  >
                    Value
                  </label>
                </div>
                <div className="d-flex align-items-center">
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => setQualityParameterValue(e.target.value)}
                    placeholder="Enter value for selected quality parameter..."
                    value={qualityParameterValue}
                    disabled={isPending}
                  />
                  <button
                    disabled={isPending}
                    className="btn btn-outline-primary ml-2"
                    type="button"
                    onClick={addQualityParam}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-2">
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: "#0D9223" }}
                disabled={isPending || !Object.keys(qualityParameter).length}
                onClick={handleSubmit}
              >
                SAVE
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UnloadingDetailsBuyerForm;
